module.exports = __webpack_public_path__ + "media/full-video.f5f4a620.mp4";